import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState([ 'selectedPostcode', 'data' ]),
  },
  methods: {
    ...mapMutations([ 'update_selected_postcode' ])
  }
}